module.exports = __webpack_public_path__ + "static/media/thumb1.af2506ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/thumb1.jpg
// module id = 368
// module chunks = 0